export const STORAGE_TOKEN_KEY = 'authorization'
export const STORAGE_LANG_KEY = 'app_lang'
export const TOKEN = 'token'
